import firebase from "firebase/app";
import "firebase/messaging";
import { notificationsService } from "../utils/NotificationsRxjs";

import config from "./firebaseConfig";

// Firebase app initialization (ensure it's done before messaging is accessed)
if (!firebase.apps.length) {
  firebase.initializeApp(config);
} else {
  firebase.app();
}

let messaging = null;
// Check if running in a browser environment and if Firebase Messaging is supported
if (typeof window !== "undefined" && firebase.messaging && typeof firebase.messaging.isSupported === 'function' && firebase.messaging.isSupported()) {
  console.log("Firebase Messaging is supported. Initializing messaging service...");
  messaging = firebase.messaging(); // Get the messaging instance
} else {
  // Only log a warning if in a browser context where messaging might have been expected
  if (typeof window !== "undefined") {
    console.warn("Firebase Messaging is not supported in this browser or context. Push notifications will not be available.");
  }
  // messaging remains null
}

export const requestFirbaseNotificationPermission = () =>
  new Promise((resolve, reject) => {
    if (!messaging) {
      const errorMsg = "Firebase Messaging is not supported or not initialized in this environment. Cannot request permission.";
      console.warn(errorMsg);
      reject(new Error(errorMsg));
      return;
    }
    messaging
      .requestPermission()
      .then(() => {
        if (!messaging) { // Should not happen if initial check passed, but good for safety
            throw new Error("Messaging became unavailable after permission request.");
        }
        return messaging.getToken();
      })
      .then((firbaseToken) => {
        if (firbaseToken) {
          resolve(firbaseToken);
        } else {
          const errorMsg = "Permission granted, but failed to retrieve Firebase token.";
          console.warn(errorMsg);
          reject(new Error(errorMsg));
        }
      })
      .catch((err) => {
        console.error("Error requesting Firebase notification permission or getting token:", err);
        let userFriendlyMessage = "Could not set up notifications. Please try again or check your browser settings.";
        if (err.code) {
            switch (err.code) {
                case 'messaging/permission-blocked':
                case 'messaging/notifications-blocked':
                    userFriendlyMessage = "Notification permission was blocked. Please enable notifications for this site in your browser settings.";
                    console.warn("Notification permission blocked. This can occur if the user denies permission, the site is not HTTPS, or (on mobile) if not triggered by a direct user action.");
                    break;
                case 'messaging/unsupported-browser':
                    userFriendlyMessage = "Notifications are not supported by your browser.";
                    console.warn("Firebase Messaging is explicitly not supported by this browser (error code).");
                    break;
                case 'messaging/failed-serviceworker-registration':
                    userFriendlyMessage = "Could not set up notifications due to a service worker issue. Please try again.";
                    console.warn("Service worker registration failed. This is required for Firebase Messaging.");
                    break;
                default:
                    console.warn(`Firebase Messaging error code: ${err.code}`);
            }
        }
        reject(new Error(userFriendlyMessage, { cause: err }));
      });
  });

export const onMessageListener = () => {
  if (!messaging) {
    console.warn("Firebase Messaging is not supported or not initialized. Cannot set up onMessage listener.");
    return () => { /* no-op unsubscribe */ }; // Return a no-op function consistent with onMessage's typical return
  }
  return messaging.onMessage((payload) => {
    console.log("Foreground message received in Firebase service: ", payload);
    notificationsService.sendNotification(payload);
  });
};